import store from '@/store';
import {VuexModule, Module, getModule, Action} from 'vuex-module-decorators';
import {UserData, SessionData, LoginHistoryItem, LoginHistoryParams} from '@/views/user/interfaces';
import {httpClient} from '@/api/baseApi';
import {config} from 'vuex-module-decorators';
config.rawError = true;

/*
    Модуль для работы с профилем пользователя
*/

const moduleName = 'userProfileModule';

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
class UserProfileModule extends VuexModule {
  //Получение данных профиля
  @Action
  async get(): Promise<UserData> {
    try {
      const {data} = await httpClient.get(`/profile`);
      return data as UserData;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Редактирование профиля
  @Action
  async save(model: UserData) {
    try {
      await httpClient.put('/profile', model);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Список сеансов
  @Action
  async list_sessions(): Promise<SessionData[]> {
    try {
      const {data} = await httpClient.get(`/profile/sessions`);
      const result: SessionData[] = data as SessionData[];
      return result.map((item: SessionData) => {
        item.timetolive =
          (item.timestamp as number) > 0
            ? new Date((item.timestamp as number) * 1000).toLocaleString('ru-RU')
            : `${item.timestamp}`;
        return item;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Закрыть сеанс(ы)
  @Action
  async close_session(sign: string) {
    console.log('close_session', sign);
    try {
      await httpClient.delete(`/profile/sessions${sign ? '/' : ''}${sign}`);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //История входов
  //Ответ сервера: [[rows...], [[name, type], ...]] — массив значений + описание колонок
  @Action
  async get_login_history(params: LoginHistoryParams): Promise<LoginHistoryItem[]> {
    try {
      const {data} = await httpClient.get(`/logs/login/me`, {params});
      const [rows, fields] = data as [any[][], any[][]];
      const names = (fields || []).map((f: any) => f[0]);
      const items: LoginHistoryItem[] = (rows || []).map((row: any) => {
        const item: any = {};
        names.forEach((name: string, i: number) => {
          item[name] = row[i];
        });
        return item as LoginHistoryItem;
      });
      return items;
    } catch (e) {
      return Promise.reject(e);
    }
  }
}

export default getModule(UserProfileModule);
